import { render, staticRenderFns } from "./BienBanNghiemThu.vue?vue&type=template&id=4d53ff20&scoped=true&"
import script from "./BienBanNghiemThu.vue?vue&type=script&lang=js&"
export * from "./BienBanNghiemThu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53ff20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
